import { redirectToAuth } from 'authorization-module'
import config from 'const/config'
import routes from 'const/routes'
import getApigeeClientId from 'helpers/getApigeeClientId'
import getLoginHintUrl from 'helpers/getLoginHintUrl'
import { Modals } from 'store/atoms/typings'
import getQueryParam from 'syf-js-utilities/formats/getQueryParam'

export interface AuthenticationRedirectProps {
  scope: string
  modal?: Modals
  navigateTo: string
}

const authenticationRedirect = (
  options?: AuthenticationRedirectProps
): void => {
  const client = getQueryParam('client') || localStorage.getItem('client')
  const sitecode = getQueryParam('sitecode')
  const authDomain = config.AUTH_DOMAIN
  const apigeeClientId = getApigeeClientId(client)
  const redirectUri = `${window.location.origin}${config.BASENAME}${routes.CALLBACK}`
  const loginHintUrl = getLoginHintUrl(client)

  if (options?.navigateTo && options?.scope) {
    const { scope, navigateTo } = options

    redirectToAuth({
      baseURL: authDomain,
      clientId: apigeeClientId,
      redirectURI: redirectUri,
      loginHintURL: loginHintUrl,
      scope,
      ...(sitecode && { sitecode }),
      navigateTo
    })

    return
  }

  redirectToAuth({
    baseURL: authDomain,
    clientId: apigeeClientId,
    redirectURI: redirectUri,
    loginHintURL: loginHintUrl,
    ...(sitecode && { sitecode })
  })
}

export const handleMFEAuthenticationRedirect = ({
  navigateTo,
  scope,
  modal
}: AuthenticationRedirectProps) => {
  const props = {
    navigateTo: JSON.stringify({
      openModal: modal,
      route: navigateTo
    }),
    scope
  }
  authenticationRedirect(props)
}

export default authenticationRedirect
